"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var icon_1 = __importDefault(require("../../icon"));
function VerTabsMobile(props) {
    var onChange = props.onChange, list = props.list;
    var _a = react_1.default.useState([{}]), options = _a[0], setOptions = _a[1];
    var _b = react_1.default.useState(''), selectVal = _b[0], setSelectVal = _b[1];
    react_1.default.useEffect(function () {
        var formateList = list.map(function (o) { return ({
            label: o.name, value: o.id,
        }); });
        setSelectVal(formateList[0].value);
        setOptions(__spreadArray([], formateList, true));
    }, [list]);
    var handleClick = function (e) {
        setSelectVal(e);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    return (react_1.default.createElement("div", { className: "tabs-ver-m" }, options.length ? react_1.default.createElement(antd_1.Select, { style: { width: '100%', lineHeight: '20px', padding: '4px 0' }, onChange: function (e) { return handleClick(e); }, options: options, value: selectVal, suffixIcon: react_1.default.createElement(icon_1.default, { name: "arrow-down", size: 24 }) }) : react_1.default.createElement(react_1.default.Fragment, null)));
}
exports.default = VerTabsMobile;
//# sourceMappingURL=VerTabsMobile.js.map